import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
`;

export const ItemRow = styled.div`
    color: #fff;
    padding: 10px 10px;
    font-size: 12px;
    height: 30px;
    min-height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    cursor: pointer;
    position: relative;

    :hover, &.selected:hover {
        background-color: #555;
    }

    &.selected {
        background-color: #444;
    }

    &.last:before {
        position: absolute;
        content: '';
        bottom: 0;
        left: 0;
        right: 0;
        box-sizing: border-box;
        border-bottom: 2px solid #555;
        border-left: 2px solid #555;
        border-right: 2px solid #555;
        width: 100%;
        height: 5px;
    }
`;

export const ItemName = styled.div`
    flex: 1;
    font-size: 12px;
`;

export const ItemValue = styled.div`
    font-size: 14px;
`;

export const ConfirmMessage = styled.div`
    flex: 1;
    font-size: 10px;
    padding: 0 0 10px 0;
    color: #fff;
`;